var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutubeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.4407 6.3402C20.9803 6.92313 21.1559 8.24711 21.1559 8.24711C21.1559 8.24711 21.3359 9.80065 21.3359 11.3548V12.811C21.3359 14.3651 21.1559 15.9186 21.1559 15.9186C21.1559 15.9186 20.9798 17.242 20.4407 17.8238C19.8234 18.5127 19.1393 18.5842 18.7528 18.6246C18.7106 18.629 18.672 18.633 18.6373 18.6375C16.1182 18.8305 12.3359 18.8372 12.3359 18.8372C12.3359 18.8372 7.6556 18.7916 6.21571 18.6442C6.14756 18.6306 6.065 18.62 5.97153 18.608C5.51554 18.5494 4.79991 18.4574 4.23115 17.8233C3.69155 17.2415 3.51599 15.9181 3.51599 15.9181C3.51599 15.9181 3.33594 14.3651 3.33594 12.8104V11.3542C3.33594 9.80065 3.51599 8.24711 3.51599 8.24711C3.51599 8.24711 3.69211 6.92313 4.23115 6.3402C4.85121 5.64887 5.5376 5.57933 5.92318 5.54027C5.96377 5.53616 6.00103 5.53238 6.03453 5.52826C8.55307 5.33301 12.3314 5.33301 12.3314 5.33301H12.3399C12.3399 5.33301 16.1182 5.33301 18.6373 5.52826C18.6709 5.53238 18.7081 5.53616 18.7488 5.54028C19.1344 5.57934 19.8212 5.6489 20.4407 6.3402ZM10.0874 15.4608V8.70873L15.7141 12.0848L10.0874 15.4608Z",
    fill: "#0B0A0B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/youtube-icon.e7291808a009e0df914edeb4ce365a65.svg";
export { ForwardRef as ReactComponent };